const t = () => ("00000000000000000" + (Math.random() * 18446744073709552e3).toString(16)).slice(-16), c = (e) => new Promise((s) => setTimeout(s, e)), i = () => {
  const e = t(), s = t();
  return e.slice(0, 8) + "-" + e.slice(8, 12) + "-4" + e.slice(13) + "-a" + s.slice(1, 4) + "-" + s.slice(4);
};
export {
  c as s,
  i as u
};
